// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"f0-z","dimensionLabel":"g0-z","styleChooserControlWrapper":"h0-z","styleChooserControl":"i0-z","disabled":"j0-z","giftCard":"k0-z","styleChooserText":"l0-z"};